export default __webpack_public_path__ + "static/media/oven-deactive.84df4fb0.svg";